import script from "./phoneInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./phoneInput.vue?vue&type=script&setup=true&lang=ts"

import "./phoneInput.vue?vue&type=style&index=0&id=6df40084&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df40084"]])

export default __exports__